export default __webpack_public_path__ + "static/media/logo_desktop_whiteVN.64dcfa29.png";